import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.NL0};
  border-radius: 8px;
  margin-left: 8px;
  margin-right: 8px;
  padding: 8px;
`;

export const MobileTourNameWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 70px;
`;
export const BadgeContainer = styled.div`
  margin-top: 8px;
  display: grid;
  align-items: end;
  gap: 8px;
`;
export const MobileTourTitle = styled.h2`
  display: block;
  height: auto;
  max-width: 100%;
  margin-bottom: 0;
  position: relative;

  &::before {
    content: '&nbsp;';
    visibility: hidden;
  }
  & span {
    position: absolute;
    left: 0;
    right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MobileTourBoardTypeWrapper = styled.div``;

export const MobileTourTimeZoneWrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;
export const MobileTourDateWrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const MobileTourButtonWrapper = styled.div`
  position: relative;
  margin-top: 8px;

  & button {
    width: 100%;
    height: 40px;
    box-shadow: none;
    background: transparent;
    border-radius: 8px;
    border: solid 1px ${({ theme }) => theme.palette.BR500};
    color: ${({ theme }) => theme.palette.BR500};
    font-weight: normal;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
  }
`;

export const MobilePriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  flex-direction: column;
`;

export const MobileTourDetailsItem = styled.div`
  display: flex;
  max-width: fit-content;
  margin-bottom: 10px;
`;

export const MobileWorldLogoWrapper = styled.div`
  margin-bottom: 0;
`;

export const MobilePriceInfoWrapper = styled.div`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MobileDiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 6px;
`;

export const MobilePriceSubLabel = styled.span`
  display: block;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.NL500};
  text-align: right;
`;

export const MobileShareWrapper = styled.div`
  position: absolute;
  right: 0px;
  top: -7px;
  display: flex;
  gap: 5px;
  align-items: start;
`;
export const BadgeWrapper = styled.div`
  display: flex;
  margin-top: 8px;
`;

export const MobileBottomContainer = styled.div`
  margin-top: 6px;
  border-top: solid 1px ${({ theme }) => theme.palette.NL30};
  display: flex;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  height: 34px;
`;
export const TourPromotions = styled.div`
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
`;
export const BottomWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 6px;
  align-items: flex-end;
  margin-top: 6px;
  overflow-x: auto;
  scrollbar-width: none;

  & div {
    height: fit-content;
    margin: 0;
  }
`;
